import { useIntl } from 'react-intl';
import { Flashbar, FlashbarProps } from '@amzn/awsui-components-react';

import { useDynamicNotifications } from '../hooks/useDynamicNotifications';
import gandalfFlashbarMessages from '../i18n/gandalfFlashbar.messages';

import styles from './GandalfFlashbar.module.css';

export const GandalfFlashbar = () => {
  const { formatMessage } = useIntl();

  const flashbarI18nStrings: FlashbarProps.I18nStrings = {
    ariaLabel: formatMessage(gandalfFlashbarMessages.ariaLabel),
    notificationBarAriaLabel: formatMessage(
      gandalfFlashbarMessages.notificationBarAriaLabel
    ),
    notificationBarText: formatMessage(
      gandalfFlashbarMessages.notificationBarText
    ),
    errorIconAriaLabel: formatMessage(
      gandalfFlashbarMessages.errorIconAriaLabel
    ),
    warningIconAriaLabel: formatMessage(
      gandalfFlashbarMessages.warningIconAriaLabel
    ),
    successIconAriaLabel: formatMessage(
      gandalfFlashbarMessages.successIconAriaLabel
    ),
    infoIconAriaLabel: formatMessage(gandalfFlashbarMessages.infoIconAriaLabel),
    inProgressIconAriaLabel: formatMessage(
      gandalfFlashbarMessages.inProgressIconAriaLabel
    ),
  };

  const messages: FlashbarProps.MessageDefinition[] = [
    useDynamicNotifications(),
  ].flat();

  return (
    <div
      className={messages.length > 0 ? styles.gandalfFlashbar : ''}
      data-testid="gandalf-flashbar"
    >
      <Flashbar
        items={messages}
        i18nStrings={flashbarI18nStrings}
        // We want the stack behavior to be the same as the SkillBuilderFlashbar
        // that is shown on the edit profile page within Skill Builder for consistency.
        // See https://tiny.amazon.com/jnm5mtcl/SkillBuilderFlashbarStackBehavior
        stackItems={messages.length > 3}
      />
    </div>
  );
};

export default GandalfFlashbar;
